<div class="container">
    <div class="main">
        <div class="title">
            {{ 'port-settings.dialog.title' | translate }}
        </div>
        <div class="column-container">
            <div class="table-row table-header">
                <div class="col-index column"></div>
                <div class="col-slave column">
                    {{ 'modbus-settings.dialog.table.slave' | translate }}
                </div>
                <div class="col-function-code column">
                    {{ 'modbus-settings.dialog.table.function-code' | translate }}
                </div>
                <div class="col-start-address column">
                    {{ 'modbus-settings.dialog.table.start-address' | translate }}
                </div>
                <div class="col-data column">
                    {{ 'modbus-settings.dialog.table.data' | translate }}
                </div>
                <div class="col-options column"></div>
            </div>
            <div *ngFor="let setting of modbusSettings; index as i" class="table-row">
                <div class="col-index column">
                    {{ setting.index }}
                </div>
                <div class="col-slave column">
                    <app-input-with-error
                        style="flex: 1"
                        [inputValue]="setting[SLAVE_INPUT]"
                        placeholder="modbus-settings.dialog.table.slave"
                        [showLegend]="false"
                        [propertyName]="SLAVE_INPUT"
                        [validatorFunction]="validatorFunction()"
                        (onInputUpdated)="onInputChange({ value: $event, name: SLAVE_INPUT }, setting)"
                        [customHeight]="'30px'"
                        maxlength="6">
                    </app-input-with-error>
                </div>
                <div class="col-function-code column">
                    <app-simple-dropdown
                        style="flex: 1"
                        [options]="functionCodeOptions"
                        [smaller]="true"
                        [selectedOption]="setting.functionCode"
                        (onOptionSelected)="handleFunctionCodeChanged($event, setting)">
                    </app-simple-dropdown>
                </div>
                <div class="col-start-address column">
                    <app-input-with-error
                        style="flex: 1"
                        [inputValue]="setting[START_ADDRESS_INPUT]"
                        placeholder="modbus-settings.dialog.table.start-address"
                        [isNumberInput]="true"
                        [showLegend]="false"
                        [propertyName]="START_ADDRESS_INPUT"
                        [validatorFunction]="validatorFunction()"
                        (onInputUpdated)="onInputChange({ value: $event, name: START_ADDRESS_INPUT }, setting)"
                        [customHeight]="'30px'"
                        maxlength="6">
                    </app-input-with-error>
                </div>
                <div class="col-data column">
                    <app-input-with-error
                        style="flex: 1"
                        [inputValue]="setting[DATA_INPUT]"
                        placeholder="modbus-settings.dialog.table.data"
                        [isNumberInput]="true"
                        [showLegend]="false"
                        [propertyName]="DATA_INPUT"
                        [validatorFunction]="validatorFunction()"
                        (onInputUpdated)="onInputChange({ value: $event, name: DATA_INPUT }, setting)"
                        [customHeight]="'30px'"
                        maxlength="6">
                    </app-input-with-error>
                </div>
                <div class="col-options column" #iconButton>
                    <mat-icon
                        svgIcon="more-options"
                        class="more-options"
                        (click)="openOptions(setting); $event.stopPropagation()">
                    </mat-icon>
                    <ng-container *ngIf="visibleSettingOptions == setting">
                        <div class="more-options-container" #otherOptions>
                            <div class="option-row" (click)="deleteSetting(setting)">
                                {{ 'dlg.delete' | translate }}
                            </div>
                            <div class="option-row" (click)="duplicate(setting)">
                                {{ 'dlg.duplicate' | translate }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="add-settings-row">
            <div class="add-button" [class.disabled]="isAddDisabled" (click)="addUnit()">
                {{ 'modbus-settings.dialog.add' | translate }}
            </div>
            <div>
                {{ 'modbus-settings.dialog.units-length' | translate: { num: modbusSettings?.length || 0 } }}
            </div>
        </div>
    </div>

    <div class="footer">
        <button class="text-button" (click)="closeDialog()">
            {{ 'dlg.cancel' | translate }}
        </button>
        <app-button
            [disable]="isSaveDisabled"
            text="dlg.save"
            customFontFamily="NotoSans-SemiBold"
            size="small"
            customFontSize="14px"
            (onClick)="save()"></app-button>
    </div>
</div>
